// State <-> JSON. Versioned envelope so the persistence layer can route through
// migrations later. eventsOut is transient — stripped on save.

import type { GameState } from '../state/types.js';

export const CURRENT_SCHEMA = 1 as const;

export type Snapshot = {
  schemaVersion: typeof CURRENT_SCHEMA;
  savedAt: string; // ISO timestamp
  state: GameState;
};

export function snapshot(state: GameState, nowIso: string): Snapshot {
  return {
    schemaVersion: CURRENT_SCHEMA,
    savedAt: nowIso,
    state: { ...state, eventsOut: [] },
  };
}

export function toJSON(snap: Snapshot): string {
  return JSON.stringify(snap);
}
